export const TargetTypes = {
  Draft: "Draft",
  Template: "Template"
};
